// components/create/LocationSearchModal.js
import React, { useState } from 'react';
import '../../styles/LocationSearchModal.scss';

export default function LocationSearchModal({ onClose, onSelectLocation }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = async (query) => {
    setSearchQuery(query);
    
    if (query.length < 3) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    
    // TODO: Implement actual search using your placesService
    // For now, just showing placeholder
    setTimeout(() => {
      setSearchResults([]);
      setIsSearching(false);
    }, 500);
  };

  const handleSelectLocation = (location) => {
    onSelectLocation(location);
  };

  return (
    <div className="location-modal-overlay" onClick={onClose}>
      <div className="location-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Search Location</h2>
          <button className="close-button" onClick={onClose}>
            <i className="icon-close"></i>
          </button>
        </div>

        <div className="search-container">
          <div className="search-box">
            <i className="icon-search"></i>
            <input
              type="text"
              className="search-input"
              placeholder="Search for a location..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
            {searchQuery && (
              <button
                className="clear-button"
                onClick={() => {
                  setSearchQuery('');
                  setSearchResults([]);
                }}
              >
                <i className="icon-close"></i>
              </button>
            )}
          </div>
        </div>

        <div className="modal-content">
          {isSearching ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Searching...</p>
            </div>
          ) : searchResults.length > 0 ? (
            <div className="results-list">
              {searchResults.map((result, index) => (
                <button
                  key={index}
                  className="result-item"
                  onClick={() => handleSelectLocation(result)}
                >
                  <i className="icon-location"></i>
                  <div className="result-text">
                    <p className="result-name">{result.display_name}</p>
                    <p className="result-address">{result.formatted_address}</p>
                  </div>
                  <i className="icon-chevron-right"></i>
                </button>
              ))}
            </div>
          ) : searchQuery.length >= 3 ? (
            <div className="empty-state">
              <i className="icon-location-outline"></i>
              <p>No locations found</p>
            </div>
          ) : (
            <div className="placeholder-state">
              <i className="icon-location-outline"></i>
              <p>Start typing to search for a location</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}